export default __webpack_public_path__ + "static/media/shaking-hands.b2005dcc.webp";